<template>
	<div class="text-justify">
		<app-overlay-loader v-if="preloader" />
		<div class="row">
			<!-- Parent Information Form -->
			<div class="col-lg-12">
				<div class="mb-4">
					<h4>Parent Information</h4>
					<hr
						style="border-top: 2px solid black; font-weight: bold"
					/>
				</div>
				<form
					ref="refParentInformationForm"
					:data-url="'/transaction/lead/' + value.id"
					class="mb-0"
					:class="{ 'loading-opacity': preloader }"
				>
					<div class="row">
						<div class="col-lg-12">
							<div class="row">
								<!-- Father First Name -->
								<div class="col-md-6">
									<div class="form-group">
										<label>Father First Name</label>
										<app-input
											type="text"
											formName="parentInfo"
											placeholder="Father First Name"
											v-model="
												parentInformationForm.father_first_name
											"
										/>
									</div>
								</div>
								<!-- Mother First Name -->
								<div class="col-md-6">
									<div class="form-group">
										<label>Mother First Name</label>
										<app-input
											type="text"
											formName="parentInfo"
											placeholder="Mother First Name"
											v-model="
												parentInformationForm.mother_first_name
											"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Father Last Name -->
								<div class="col-md-6">
									<div class="form-group">
										<label>Father Last Name</label>
										<app-input
											type="text"
											formName="parentInfo"
											placeholder="Father Last Name"
											v-model="
												parentInformationForm.father_last_name
											"
										/>
									</div>
								</div>
								<!-- Mother Last Name -->
								<div class="col-md-6">
									<div class="form-group">
										<label>Mother Last Name</label>
										<app-input
											type="text"
											formName="parentInfo"
											placeholder="Mother Last Name"
											v-model="
												parentInformationForm.mother_last_name
											"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Contact Number -->
								<div class="col-md-6">
									<div class="form-group">
										<label for="inputs_father_mobile">
											Contact Number
										</label>
										<app-input
											id="inputs_father_mobile"
											formName="parentInfo"
											type="tel-input"
											v-model="
												parentInformationForm.father_mobile
											"
											name="father_mobile"
											placeholder="Contact Number"
											required
										/>
									</div>
								</div>
								<!-- Contact Number -->
								<div class="col-md-6">
									<div class="form-group">
										<label for="inputs_mother_mobile">
											Contact Number
										</label>
										<app-input
											id="inputs_mother_mobile"
											formName="parentInfo"
											type="tel-input"
											v-model="
												parentInformationForm.mother_mobile
											"
											name="mother_mobile"
											placeholder="Contact Number"
											required
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Home Phone Number -->
								<div class="col-md-6">
									<div class="form-group">
										<label for="inputs_father_phone">
											Home Phone Number
										</label>
										<app-input
											id="inputs_father_phone"
											formName="parentInfo"
											type="tel-input"
											v-model="
												parentInformationForm.father_phone
											"
											name="father_phone"
											placeholder="Home Phone Number"
											required
										/>
									</div>
								</div>
								<!-- Home Phone Number -->
								<div class="col-md-6">
									<div class="form-group">
										<label for="inputs_mother_phone">
											Home Phone Number
										</label>
										<app-input
											id="inputs_mother_phone"
											formName="parentInfo"
											type="tel-input"
											v-model="
												parentInformationForm.mother_phone
											"
											name="mother_phone"
											placeholder="Home Phone Number"
											required
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Whatsapp Number -->
								<div class="col-md-6">
									<div class="form-group">
										<label for="inputs_father_wa">
											Whatsapp Number
										</label>
										<app-input
											id="inputs_father_wa"
											formName="parentInfo"
											type="tel-input"
											v-model="
												parentInformationForm.father_wa
											"
											name="father_wa"
											placeholder="Whatsapp Number"
											required
										/>
									</div>
								</div>
								<!-- Whatsapp Number -->
								<div class="col-md-6">
									<div class="form-group">
										<label for="inputs_mother_wa">
											Whatsapp Number
										</label>
										<app-input
											id="inputs_mother_wa"
											formName="parentInfo"
											type="tel-input"
											v-model="
												parentInformationForm.mother_wa
											"
											name="mother_wa"
											placeholder="Whatsapp Number"
											required
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Email Address -->
								<div class="col-md-6">
									<div class="form-group">
										<label>Email Address</label>
										<app-input
											type="email"
											formName="parentInfo"
											placeholder="Email Address"
											v-model="
												parentInformationForm.father_email
											"
										/>
									</div>
								</div>
								<!-- Email Address -->
								<div class="col-md-6">
									<div class="form-group">
										<label>Email Address</label>
										<app-input
											type="email"
											formName="parentInfo"
											placeholder="Email Address"
											v-model="
												parentInformationForm.mother_email
											"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Submit and Clear button -->
					<div class="mb-5 action-buttons">
						<button
							type="submit"
							class="btn btn-primary mr-2"
							:disabled="submitParentInformationFormDisabled"
							@click.prevent="submitParentInformationForm"
						>
							{{ $t("submit") }}
						</button>
						<!-- <button
							type="button"
							class="btn btn-secondary"
							@click="clearParentInformationForm"
						>
							Clear
						</button> -->
					</div>
				</form>
			</div>

			<div class="col-lg-12">
				<student-profile-tab-personal-sibling-information-table
					:value="value"
				></student-profile-tab-personal-sibling-information-table>
			</div>

			<!-- Primary Address Form -->
			<div class="col-lg-6 mt-8">
				<div class="mb-4">
					<h4>Primary Address</h4>
					<hr
						style="border-top: 2px solid black; font-weight: bold"
					/>
				</div>
				<form
					ref="refPrimaryAddressForm"
					:data-url="'/transaction/lead/' + value.id"
					class="mb-0"
					:class="{ 'loading-opacity': preloader }"
				>
					<div class="row">
						<!-- Country -->
						<div class="col-md-6">
							<label>Choose Country</label>
							<app-input
								type="advance-search-select"
								formName="primaryAddress"
								:loaded-per-time="10"
								v-model="input_country"
								@input="setCountryValue"
								fetch-url="master/country"
								placeholder="Choose Country"
								list-value-field="name"
								required
							/>
						</div>
						<!-- Postcode -->
						<div class="col-md-6">
							<div class="form-group">
								<label>Postcode</label>
								<app-input
									type="advance-search-select"
									formName="primaryAddress"
									:loaded-per-time="10"
									v-model="input_postcode"
									@input="setPostCodeValue"
									:fetch-url="`master/village?city_id=${input_city.id}`"
									placeholder="Choose Postcode"
									list-value-field="full_location"
									required
								/>
							</div>
						</div>
						<!-- State/Province -->
						<div class="col-md-6">
							<div class="form-group">
								<label>State/Province</label>
								<app-input
									type="advance-search-select"
									formName="primaryAddress"
									:loaded-per-time="10"
									v-model="input_province"
									@input="setProvinceValue"
									:fetch-url="`master/province?country_id=${input_country.id}`"
									:placeholder="$t('province')"
									list-value-field="name"
									:required="true"
								/>
							</div>
						</div>
						<!-- City -->
						<div class="col-md-6">
							<div class="form-group">
								<label>City/Suburb</label>
								<app-input
									type="advance-search-select"
									formName="primaryAddress"
									:loaded-per-time="10"
									v-model="input_city"
									@input="setCityValue"
									:fetch-url="`master/city?province_id=${input_province.id}&country_id=${input_country.id}`"
									:placeholder="$t('city')"
									list-value-field="name"
									:required="true"
								/>
							</div>
						</div>
						<!-- "Address" -->
						<div class="col-md-12">
							<div class="form-group">
								<label>Address</label>
								<textarea
									class="form-control"
									v-model="
										primaryAddressForm.address_0_street
									"
									placeholder="Address"
									name="address"
									rows="6"
								></textarea>
							</div>
						</div>
					</div>

					<!-- Submit and Clear button -->
					<div class="mb-5 action-buttons">
						<button
							type="submit"
							class="btn btn-primary mr-2"
							:disabled="submitPrimaryAddressFormDisabled"
							@click.prevent="submitPrimaryAddressForm"
						>
							{{ $t("submit") }}
						</button>
						<!-- <button
							type="button"
							class="btn btn-secondary"
							@click="clearPrimaryAddress"
						>
							Clear
						</button> -->
					</div>
				</form>
			</div>
			<!-- Secondary Address Form -->
			<div class="col-lg-6 mt-8">
				<div class="mb-4">
					<div class="row">
						<div class="col-md-6">
							<h4>Secondary Address</h4>
						</div>
						<div class="col-md-6">
							<!-- checkbox Same as Primary Address -->
							<div class="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									value=""
									id="same_as_primary_address"
									v-model="sameAsPrimaryAddress"
									style="
										transform: scale(1.5);
										margin-right: 10px;
									"
								/>
								<label
									class="form-check-label"
									for="same_as_primary_address"
									style="font-size: 18px"
								>
									Same as Primary Address
								</label>
							</div>
						</div>
					</div>
					<hr
						style="border-top: 2px solid black; font-weight: bold"
					/>
				</div>
				<form
					ref="refSecondaryAddressForm"
					:data-url="'/transaction/lead/' + value.id"
					class="mb-0"
					:class="{ 'loading-opacity': preloader }"
				>
					<div class="row">
						<!-- Country -->
						<div class="col-md-6">
							<label>Choose Country</label>
							<app-input
								type="advance-search-select"
								formName="secondaryAddress"
								:loaded-per-time="10"
								v-model="input_country_secondary"
								@input="setCountrySecondaryValue"
								fetch-url="master/country"
								placeholder="Choose Country"
								list-value-field="name"
								required
							/>
						</div>
						<!-- Postcode -->
						<div class="col-md-6">
							<div class="form-group">
								<label>Postcode</label>
								<app-input
									type="advance-search-select"
									formName="secondaryAddress"
									:loaded-per-time="10"
									v-model="input_postcode_secondary"
									@input="setPostCodeSecondaryValue"
									:fetch-url="`master/village?city_id=${input_city_secondary.id}`"
									placeholder="Choose Postcode"
									list-value-field="full_location"
									required
								/>
							</div>
						</div>
						<!-- State/Province -->
						<div class="col-md-6">
							<div class="form-group">
								<label>State/Province</label>
								<app-input
									type="advance-search-select"
									formName="secondaryAddress"
									:loaded-per-time="10"
									v-model="input_province_secondary"
									@input="setProvinceSecondaryValue"
									:fetch-url="`master/province?country_id=${input_country_secondary.id}`"
									:placeholder="$t('province')"
									list-value-field="name"
									:required="true"
								/>
							</div>
						</div>
						<!-- City -->
						<div class="col-md-6">
							<div class="form-group">
								<label>City/Suburb</label>
								<app-input
									type="advance-search-select"
									formName="secondaryAddress"
									:loaded-per-time="10"
									v-model="input_city_secondary"
									@input="setCitySecondaryValue"
									:fetch-url="`master/city?province_id=${input_province_secondary.id}&country_id=${input_country_secondary.id}`"
									:placeholder="$t('city')"
									list-value-field="name"
									:required="true"
								/>
							</div>
						</div>
						<!-- "Address" -->
						<div class="col-md-12">
							<div class="form-group">
								<label>Address</label>
								<textarea
									class="form-control"
									v-model="
										secondaryAddressForm.address_1_street
									"
									placeholder="Address"
									name="address"
									rows="6"
								></textarea>
							</div>
						</div>
					</div>

					<!-- Submit and Clear button -->
					<div class="mb-5 action-buttons">
						<button
							type="submit"
							class="btn btn-primary mr-2"
							:disabled="submitSecondaryAddressFormDisabled"
							@click.prevent="submitSecondaryAddressForm"
						>
							{{ $t("submit") }}
						</button>
						<!-- <button
							type="button"
							class="btn btn-secondary"
							@click="clearSecondaryAddress"
						>
							Clear
						</button> -->
					</div>
				</form>
			</div>
			<!-- Email Address for Communication Form -->
			<div class="col-lg-12 mt-8">
				<div class="mb-4">
					<h4>Email Address for Communication</h4>
					<hr
						style="border-top: 2px solid black; font-weight: bold"
					/>
				</div>
				<form
					ref="refEmailAddressCommunicationForm"
					:data-url="'/transaction/lead/' + value.id"
					class="mb-0"
					:class="{ 'loading-opacity': preloader }"
				>
					<div class="row">
						<div class="col-lg-12">
							<div class="row">
								<!-- Notification for Announcement -->
								<div class="col-md-4">
									<label>
										Notification for Announcement
									</label>
									<app-input
										type="checkbox"
										formName="emailAddressCommunicationForm"
										:list="fatherMotherCheckbox"
										v-model="
											emailAddressCommunicationForm.notification
										"
									/>
								</div>
								<!-- Daily Tools -->
								<div class="col-md-4">
									<label> Daily Tools </label>
									<app-input
										type="email"
										formName="emailAddressCommunicationForm"
										name="daily_tool"
										placeholder="Daily Tools (Email Address)"
										v-model="
											emailAddressCommunicationForm.daily_tool
										"
									/>
								</div>
								<!-- Billing or Invoices -->
								<div class="col-md-4">
									<label> Billing or Invoices </label>
									<app-input
										type="checkbox"
										formName="emailAddressCommunicationForm"
										:list="fatherMotherCheckbox"
										v-model="
											emailAddressCommunicationForm.billing
										"
									/>
								</div>
							</div>
						</div>
					</div>

					<!-- Submit and Clear button -->
					<div class="mt-5 mb-5 action-buttons">
						<button
							type="submit"
							class="btn btn-primary mr-2"
							:disabled="
								submitEmailAddressCommunicationFormDisabled
							"
							@click.prevent="submitEmailAddressCommunicationForm"
						>
							{{ $t("submit") }}
						</button>
						<!-- <button
							type="button"
							class="btn btn-secondary"
							@click="clearEmailAddressCommunication"
						>
							Clear
						</button> -->
					</div>
				</form>
			</div>

			<!-- Emergency Contact Form -->
			<div class="col-lg-12">
				<div class="mb-4">
					<h4>Emergency Contact</h4>
					<hr
						style="border-top: 2px solid black; font-weight: bold"
					/>
				</div>
				<form
					ref="refEmergencyContactForm"
					:data-url="'/transaction/lead/' + value.id"
					class="mb-0"
					:class="{ 'loading-opacity': preloader }"
				>
					<div class="row">
						<div class="col-lg-12">
							<div class="row">
								<!-- Contact Name #1 -->
								<div class="col-md-6">
									<div class="form-group">
										<label>Contact Name #1</label>
										<app-input
											type="text"
											formName="emergencyContact"
											placeholder="Contact Name #1"
											v-model="
												emergencyContactForm.emergency_0_contact
											"
										/>
									</div>
								</div>
								<!-- Contact Name #2 -->
								<div class="col-md-6">
									<div class="form-group">
										<label>Contact Name #2</label>
										<app-input
											type="text"
											formName="emergencyContact"
											placeholder="Contact Name #2"
											v-model="
												emergencyContactForm.emergency_1_contact
											"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Relationship -->
								<div class="col-md-6">
									<div class="form-group">
										<label>Relationship</label>
										<app-input
											type="text"
											formName="emergencyContact"
											placeholder="Relationship"
											v-model="
												emergencyContactForm.emergency_0_relation
											"
										/>
									</div>
								</div>
								<!-- Relationship -->
								<div class="col-md-6">
									<div class="form-group">
										<label>Relationship</label>
										<app-input
											type="text"
											formName="emergencyContact"
											placeholder="Relationship"
											v-model="
												emergencyContactForm.emergency_1_relation
											"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Contact Number -->
								<div class="col-md-6">
									<div class="form-group">
										<label for="inputs_emergency_0_mobile">
											Contact Number
										</label>
										<app-input
											id="inputs_emergency_0_mobile"
											type="tel-input"
											v-model="
												emergencyContactForm.emergency_0_mobile
											"
											name="emergency_0_mobile"
											placeholder="Contact Number"
											required
										/>
									</div>
								</div>
								<!-- Contact Number -->
								<div class="col-md-6">
									<div class="form-group">
										<label for="inputs_emergency_1_mobile">
											Contact Number
										</label>
										<app-input
											id="inputs_emergency_1_mobile"
											type="tel-input"
											v-model="
												emergencyContactForm.emergency_1_mobile
											"
											name="emergency_1_mobile"
											placeholder="Contact Number"
											required
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Whatsapp Number -->
								<div class="col-md-6">
									<div class="form-group">
										<label for="inputs_emergency_0_wa">
											Whatsapp Number
										</label>
										<app-input
											id="inputs_emergency_0_wa"
											type="tel-input"
											v-model="
												emergencyContactForm.emergency_0_wa
											"
											name="emergency_0_wa"
											placeholder="Whatsapp Number"
											required
										/>
									</div>
								</div>
								<!-- Whatsapp Number -->
								<div class="col-md-6">
									<div class="form-group">
										<label for="inputs_emergency_1_wa">
											Whatsapp Number
										</label>
										<app-input
											id="inputs_emergency_1_wa"
											type="tel-input"
											v-model="
												emergencyContactForm.emergency_1_wa
											"
											name="emergency_1_wa"
											placeholder="Whatsapp Number"
											required
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Email Address -->
								<div class="col-md-6">
									<div class="form-group">
										<label>Email Address</label>
										<app-input
											type="email"
											formName="emergencyContact"
											placeholder="Email Address"
											v-model="
												emergencyContactForm.emergency_0_email
											"
										/>
									</div>
								</div>
								<!-- Email Address -->
								<div class="col-md-6">
									<div class="form-group">
										<label>Email Address</label>
										<app-input
											type="email"
											formName="emergencyContact"
											placeholder="Email Address"
											v-model="
												emergencyContactForm.emergency_1_email
											"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Submit and Clear button -->
					<div class="mb-5 action-buttons">
						<button
							type="submit"
							class="btn btn-primary mr-2"
							:disabled="submitEmergencyContactFormDisabled"
							@click.prevent="submitEmergencyContactForm"
						>
							{{ $t("submit") }}
						</button>
						<!-- <button
							type="button"
							class="btn btn-secondary"
							@click="clearEmergencyContactForm"
						>
							Clear
						</button> -->
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { ParentInformationFormMixin } from "./ParentInformationFormMixin.js";
import { PrimaryAddressFormMixin } from "./PrimaryAddressFormMixin.js";
import { SecondaryAddressFormMixin } from "./SecondaryAddressFormMixin.js";
import { EmailAddressCommunicationFormMixin } from "./EmailAddressCommunicationFormMixin.js";
import { EmergencyContactFormMixin } from "./EmergencyContactFormMixin.js";
import GlobalHelperMixin from "../../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	name: "StudentTabPersonal",
	mixins: [
		ParentInformationFormMixin,
		PrimaryAddressFormMixin,
		SecondaryAddressFormMixin,
		EmailAddressCommunicationFormMixin,
		EmergencyContactFormMixin,
		GlobalHelperMixin,
	],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			submitParentInformationFormDisabled: true,
			originalParentInformationForm: {},
			submitPrimaryAddressFormDisabled: true,
			originalPrimaryAddressForm: {},
			submitSecondaryAddressFormDisabled: true,
			originalSecondaryAddressForm: {},
			submitEmailAddressCommunicationFormDisabled: true,
			originalEmailAddressCommunicationForm: {},
			submitEmergencyContactFormDisabled: true,
			originalEmergencyContactForm: {},
			sameAsPrimaryAddress: false,
			parentInformationForm: {
				father_first_name: this.value.parent?.is_mother == 0
					? this.value.parent?.name
					: "",
				father_last_name: this.value.parent?.is_mother == 0
					? this.value.parent?.last_name_parents
					: "",
				mother_first_name: this.value.parent?.is_mother == 1
					? this.value.parent?.name
					: "",
				mother_last_name: this.value.parent?.is_mother == 1 ? this.value.parent?.last_name_parents : "",
				is_mother: this.value.parent?.is_mother,
				parent_id: this.value.parent?.id,
				father_mobile: this.value.father_mobile,
				mother_mobile: this.value.mother_mobile,
				father_phone: this.value.father_phone,
				mother_phone: this.value.mother_phone,
				father_wa: this.value.father_wa,
				mother_wa: this.value.mother_wa,
				father_email: this.value.father_email,
				mother_email: this.value.mother_email,
			},
			primaryAddressForm: {
				address_0_country: this.value.address_0_country?.id || "",
				address_0_postcode: this.value.address_0_postcode?.id || "",
				address_0_province: this.value.address_0_province?.id || "",
				address_0_city: this.value.address_0_city?.id || "",
				address_0_street: this.value.address_0_street || "",
			},
			secondaryAddressForm: {
				address_1_country: this.value.address_1_country?.id || "",
				address_1_postcode: this.value.address_1_postcode?.id || "",
				address_1_province: this.value.address_1_province?.id || "",
				address_1_city: this.value.address_1_city?.id || "",
				address_1_street: this.value.address_1_street || "",
			},
			emailAddressCommunicationForm: {
				notification: this.value.notification,
				daily_tool: this.value.daily_tool,
				billing: this.value.billing,
			},
			emergencyContactForm: {
				emergency_0_contact: this.value.emergency_0_contact,
				emergency_1_contact: this.value.emergency_1_contact,
				emergency_0_relation: this.value.emergency_0_relation,
				emergency_1_relation: this.value.emergency_1_relation,
				emergency_0_mobile: this.value.emergency_0_mobile,
				emergency_1_mobile: this.value.emergency_1_mobile,
				emergency_0_wa: this.value.emergency_0_wa,
				emergency_1_wa: this.value.emergency_1_wa,
				emergency_0_email: this.value.emergency_0_email,
				emergency_1_email: this.value.emergency_1_email,
			},
			input_country: this.value
				? this.value.address_0_country
					? {
							id: this.value.address_0_country.id || 0,
							name: this.value.address_0_country.name || "",
							code: this.value.address_0_country.code,
							is_active: this.value.address_0_country.is_active,
					  }
					: {
							id: this.value.address_0_country?.id || 0,
							name: this.value.address_0_country?.name || "",
							code: this.value.address_0_country?.code,
							is_active: this.value.address_0_country?.is_active,
					  }
				: {
						id: this.value.address_0_country.id || 0,
						name: this.value.address_0_country.name || "",
						code: this.value.address_0_country.code,
						is_active: this.value.address_0_country.is_active,
				  },
			input_province: this.value
				? this.value.address_0_province
					? {
							id: this.value.address_0_province.id || 0,
							name: this.value.address_0_province.name || "",
							code: this.value.address_0_province.code,
							is_active: this.value.address_0_province.is_active,
					  }
					: {
							id: this.value.address_0_province?.id || 0,
							name: this.value.address_0_province?.name || "",
							code: this.value.address_0_province?.code,
							is_active: this.value.address_0_province?.is_active,
					  }
				: {
						id: this.value.address_0_province.id || 0,
						name: this.value.address_0_province.name || "",
						code: this.value.address_0_province.code,
						is_active: this.value.address_0_province.is_active,
				  },
			input_city: this.value
				? this.value.address_0_city
					? {
							id: this.value.address_0_city.id || 0,
							name: this.value.address_0_city.name || "",
							code: this.value.address_0_city.code,
							is_active: this.value.address_0_city.is_active,
					  }
					: {
							id: this.value.address_0_city?.id || 0,
							name: this.value.address_0_city?.name || "",
							code: this.value.address_0_city?.code,
							is_active: this.value.address_0_city?.is_active,
					  }
				: {
						id: this.value.address_0_city.id || 0,
						name: this.value.address_0_city.name || "",
						code: this.value.address_0_city.code,
						is_active: this.value.address_0_city.is_active,
				  },
			input_postcode: this.value
				? this.value.address_0_postcode
					? {
							id: this.value.address_0_postcode.id || 0,
							postal_code:
								this.value.address_0_postcode.postal_code || "",
							full_location:
								this.value.address_0_postcode.full_location ||
								"",
							code: this.value.address_0_postcode.code,
							is_active: this.value.address_0_postcode.is_active,
							name: this.value.address_0_postcode.name || "",
					  }
					: {
							id: this.value.address_0_postcode?.id || 0,
							postal_code:
								this.value.address_0_postcode?.postal_code ||
								"",
							full_location:
								this.value.address_0_postcode?.full_location ||
								"",
							code: this.value.address_0_postcode?.code,
							is_active: this.value.address_0_postcode?.is_active,
							name: this.value.address_0_postcode?.name || "",
					  }
				: {
						id: this.value.address_0_postcode.id || 0,
						postal_code:
							this.value.address_0_postcode.postal_code || "",
						full_location:
							this.value.address_0_postcode.full_location || "",
						code: this.value.address_0_postcode.code,
						is_active: this.value.address_0_postcode.is_active,
						name: this.value.address_0_postcode.name || "",
				  },
			// SECONDARY ADDRESS
			// SECONDARY ADDRESS
			// SECONDARY ADDRESS
			input_country_secondary: this.value
				? this.value.address_1_country
					? {
							id: this.value.address_1_country.id || 0,
							name: this.value.address_1_country.name || "",
							code: this.value.address_1_country.code,
							is_active: this.value.address_1_country.is_active,
					  }
					: {
							id: this.value.address_1_country?.id || 0,
							name: this.value.address_1_country?.name || "",
							code: this.value.address_1_country?.code,
							is_active: this.value.address_1_country?.is_active,
					  }
				: {
						id: this.value.address_1_country.id || 0,
						name: this.value.address_1_country.name || "",
						code: this.value.address_1_country.code,
						is_active: this.value.address_1_country.is_active,
				  },
			input_province_secondary: this.value
				? this.value.address_1_province
					? {
							id: this.value.address_1_province.id || 0,
							name: this.value.address_1_province.name || "",
							code: this.value.address_1_province.code,
							is_active: this.value.address_1_province.is_active,
					  }
					: {
							id: this.value.address_1_province?.id || 0,
							name: this.value.address_1_province?.name || "",
							code: this.value.address_1_province?.code,
							is_active: this.value.address_1_province?.is_active,
					  }
				: {
						id: this.value.address_1_province.id || 0,
						name: this.value.address_1_province.name || "",
						code: this.value.address_1_province.code,
						is_active: this.value.address_1_province.is_active,
				  },
			input_city_secondary: this.value
				? this.value.address_1_city
					? {
							id: this.value.address_1_city.id || 0,
							name: this.value.address_1_city.name || "",
							code: this.value.address_1_city.code,
							is_active: this.value.address_1_city.is_active,
					  }
					: {
							id: this.value.address_1_city?.id || 0,
							name: this.value.address_1_city?.name || "",
							code: this.value.address_1_city?.code,
							is_active: this.value.address_1_city?.is_active,
					  }
				: {
						id: this.value.address_1_city.id || 0,
						name: this.value.address_1_city.name || "",
						code: this.value.address_1_city.code,
						is_active: this.value.address_1_city.is_active,
				  },
			input_postcode_secondary: this.value
				? this.value.address_1_postcode
					? {
							id: this.value.address_1_postcode.id || 0,
							postal_code:
								this.value.address_1_postcode.postal_code || "",
							full_location:
								this.value.address_1_postcode.full_location ||
								"",
							code: this.value.address_1_postcode.code,
							is_active: this.value.address_1_postcode.is_active,
							name: this.value.address_1_postcode.name || "",
					  }
					: {
							id: this.value.address_1_postcode?.id || 0,
							postal_code:
								this.value.address_1_postcode?.postal_code ||
								"",
							full_location:
								this.value.address_1_postcode?.full_location ||
								"",
							code: this.value.address_1_postcode?.code,
							is_active: this.value.address_1_postcode?.is_active,
							name: this.value.address_1_postcode?.name || "",
					  }
				: {
						id: this.value.address_1_postcode.id || 0,
						postal_code:
							this.value.address_1_postcode.postal_code || "",
						full_location:
							this.value.address_1_postcode.full_location || "",
						code: this.value.address_1_postcode.code,
						is_active: this.value.address_1_postcode.is_active,
						name: this.value.address_1_postcode.name || "",
				  },
			fatherMotherCheckbox: [
				{
					id: 1,
					value: "Father",
				},
				{
					id: 2,
					value: "Mother",
				},
			],
		};
	},
	created() {
		this.originalParentInformationForm = JSON.parse(
			JSON.stringify(this.parentInformationForm)
		);
		this.originalPrimaryAddressForm = JSON.parse(
			JSON.stringify(this.primaryAddressForm)
		);
		this.originalSecondaryAddressForm = JSON.parse(
			JSON.stringify(this.secondaryAddressForm)
		);
		this.originalEmailAddressCommunicationForm = JSON.parse(
			JSON.stringify(this.emailAddressCommunicationForm)
		);
		this.originalEmergencyContactForm = JSON.parse(
			JSON.stringify(this.emergencyContactForm)
		);
	},
	mounted() {
		// Set data awal
		this.splitFatherName();

	},
	methods: {
		splitFatherName() {
			const parts = (this.value.father_name || "").split(" ");
			this.parentInformationForm.father_first_name = parts[0] || "";
			this.parentInformationForm.father_last_name = parts.slice(1).join(" ") || "";
		},
		// PARENT INFORMATION FORM
		beforeSubmitParentInformationForm() {
			this.preloader = true;
		},
		submitParentInformationForm() {
			// Handle form submission here
			this.originalParentInformationForm = JSON.parse(
				JSON.stringify(this.parentInformationForm)
			);
			this.submitParentInformationFormDisabled =
				JSON.stringify(this.parentInformationForm) ===
				JSON.stringify(this.originalParentInformationForm);
			this.parentInformationForm.parent = {
				id: this.parentInformationForm.parent_id,
				name: this.parentInformationForm.is_mother == 0
					? this.parentInformationForm.father_first_name
					: this.parentInformationForm.mother_first_name,
				last_name_parents: this.parentInformationForm.is_mother == 0
					? this.parentInformationForm.father_last_name
					: this.parentInformationForm.mother_last_name,
			};
			this.saveParentInformationForm(this.parentInformationForm);
		},
		afterSuccessParentInformationForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearParentInformationForm();
		},
		afterFinalResponseParentInformationForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorParentInformationForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearParentInformationForm() {
			// Clear form fields here
			this.parentInformationForm = {};
			// this.basicInfo.custom_file = null;
		},

		// PRIMARY ADDRESS
		beforeSubmitPrimaryAddressForm() {
			this.preloader = true;
		},
		submitPrimaryAddressForm() {
			// Handle form submission here
			this.originalPrimaryAddressForm = JSON.parse(
				JSON.stringify(this.primaryAddressForm)
			);
			this.submitPrimaryAddressFormDisabled =
				JSON.stringify(this.primaryAddressForm) ===
				JSON.stringify(this.originalPrimaryAddressForm);
			this.savePrimaryAddressForm(this.primaryAddressForm);
		},
		afterSuccessPrimaryAddressForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearPrimaryAddressForm();
		},
		afterFinalResponsePrimaryAddressForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorPrimaryAddressForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearPrimaryAddressForm() {
			// Clear form fields here
			this.primaryAddressForm = {};
			// this.basicInfo.custom_file = null;
		},

		// SECONDARY ADDRESS
		beforeSubmitSecondaryAddressForm() {
			this.preloader = true;
		},
		submitSecondaryAddressForm() {
			// Handle form submission here
			this.originalSecondaryAddressForm = JSON.parse(
				JSON.stringify(this.secondaryAddressForm)
			);
			this.submitSecondaryAddressFormDisabled =
				JSON.stringify(this.secondaryAddressForm) ===
				JSON.stringify(this.originalSecondaryAddressForm);
			this.saveSecondaryAddressForm(this.secondaryAddressForm);
		},
		afterSuccessSecondaryAddressForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearSecondaryAddressForm();
		},
		afterFinalResponseSecondaryAddressForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorSecondaryAddressForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearSecondaryAddressForm() {
			// Clear form fields here
			this.secondaryAddressForm = {};
			// this.basicInfo.custom_file = null;
		},

		// EMAIL ADDRESS FOR COMMUNICATION
		beforeSubmitEmailAddressCommunicationForm() {
			this.preloader = true;
		},
		submitEmailAddressCommunicationForm() {
			// Handle form submission here
			this.emailAddressCommunicationForm.notification =
				this.parseIntFatherMotherCheckbox(
					this.emailAddressCommunicationForm.notification
				);
			this.emailAddressCommunicationForm.billing =
				this.parseIntFatherMotherCheckbox(
					this.emailAddressCommunicationForm.billing
				);

			this.originalEmailAddressCommunicationForm = JSON.parse(
				JSON.stringify(this.emailAddressCommunicationForm)
			);
			this.submitEmailAddressCommunicationFormDisabled =
				JSON.stringify(this.emailAddressCommunicationForm) ===
				JSON.stringify(this.originalEmailAddressCommunicationForm);
			this.saveEmailAddressCommunicationForm(
				this.emailAddressCommunicationForm
			);
		},
		afterSuccessEmailAddressCommunicationForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearEmailAddressCommunicationForm();
		},
		afterFinalResponseEmailAddressCommunicationForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorEmailAddressCommunicationForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearEmailAddressCommunicationForm() {
			// Clear form fields here
			this.emailAddressCommunicationForm = {};
			// this.basicInfo.custom_file = null;
		},

		// EMERGENCY FORM
		beforeSubmitEmergencyContactForm() {
			this.preloader = true;
		},
		submitEmergencyContactForm() {
			// Handle form submission here
			this.originalEmergencyContactForm = JSON.parse(
				JSON.stringify(this.emergencyContactForm)
			);
			this.submitEmergencyContactFormDisabled =
				JSON.stringify(this.emergencyContactForm) ===
				JSON.stringify(this.originalEmergencyContactForm);
			this.saveEmergencyContactForm(this.emergencyContactForm);
		},
		afterSuccessEmergencyContactForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearEmergencyContactForm();
		},
		afterFinalResponseEmergencyContactForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorEmergencyContactForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearEmergencyContactForm() {
			// Clear form fields here
			this.emergencyContactForm = {};
			// this.basicInfo.custom_file = null;
		},

		// PRIMARY ADDRESS - ADVANCE SEARCH SELECT
		// PRIMARY ADDRESS - ADVANCE SEARCH SELECT
		// PRIMARY ADDRESS - ADVANCE SEARCH SELECT
		setCountryValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.primaryAddressForm.address_0_country = data.id;
			}
			this.resetProvince();
		},
		setProvinceValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.primaryAddressForm.address_0_province = data.id;
			}
			this.resetCity();
		},
		setCityValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.primaryAddressForm.address_0_city = data.id;
			}
			this.resetPostcode();
		},
		setPostCodeValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.primaryAddressForm.address_0_postcode = data.id;
			}
		},
		resetProvince() {
			this.input_province = {
				province_id: "",
				code: "",
				name: "",
				is_active: "",
				province: {
					id: "",
					code: "",
					name: "",
					is_active: "",
				},
			};
		},
		resetCity() {
			this.input_city = {
				country_id: "",
				province_id: "",
				city_id: "",
				code: "",
				name: "",
				is_active: "",
				city: {
					id: "",
					code: "",
					name: "",
					is_active: "",
				},
			};
		},
		resetPostcode() {
			this.input_postcode = {
				country_id: "",
				province_id: "",
				city_id: "",
				id: "",
				postal_code: "",
				full_location: "",
				code: "",
				is_active: "",
				postcode: {
					id: "",
					postal_code: "",
					full_location: "",
					code: "",
					is_active: "",
				},
			};
		},
		// SECONDARY ADDRESS - ADVANCE SEARCH SELECT
		// SECONDARY ADDRESS - ADVANCE SEARCH SELECT
		// SECONDARY ADDRESS - ADVANCE SEARCH SELECT
		setCountrySecondaryValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.secondaryAddressForm.address_1_country = data.id;
			}
			this.resetProvinceSecondary();
		},
		setProvinceSecondaryValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.secondaryAddressForm.address_1_province = data.id;
			}
			this.resetCitySecondary();
		},
		setCitySecondaryValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.secondaryAddressForm.address_1_city = data.id;
			}
			this.resetPostcodeSecondary();
		},
		setPostCodeSecondaryValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.secondaryAddressForm.address_1_postcode = data.id;
			}
		},
		resetCountrySecondary() {
			this.input_country_secondary = {
				id: "",
				name: "",
				code: "",
				is_active: "",
			};
		},
		resetProvinceSecondary() {
			this.input_province_secondary = {
				province_id: "",
				code: "",
				name: "",
				is_active: "",
				province: {
					id: "",
					code: "",
					name: "",
					is_active: "",
				},
			};
		},
		resetCitySecondary() {
			this.input_city_secondary = {
				country_id: "",
				province_id: "",
				city_id: "",
				code: "",
				name: "",
				is_active: "",
				city: {
					id: "",
					code: "",
					name: "",
					is_active: "",
				},
			};
		},
		resetPostcodeSecondary() {
			this.input_postcode_secondary = {
				country_id: "",
				province_id: "",
				city_id: "",
				id: "",
				postal_code: "",
				full_location: "",
				code: "",
				is_active: "",
				postcode: {
					id: "",
					postal_code: "",
					full_location: "",
					code: "",
					is_active: "",
				},
			};
		},
		parseIntFatherMotherCheckbox(val) {
			return val.map((item) => parseInt(item));
		},
	},
	watch: {
		input_country: {
			handler: function (val) {
				if (val) {
					this.primaryAddressForm.address_0_country = val.id;
				}
			},
			deep: true,
		},
		input_province: {
			handler: function (val) {
				if (val) {
					this.primaryAddressForm.address_0_province = val.id;
				}
			},
			deep: true,
		},
		input_city: {
			handler: function (val) {
				if (val) {
					this.primaryAddressForm.address_0_city = val.id;
				}
			},
			deep: true,
		},
		input_postcode: {
			handler: function (val) {
				if (val) {
					this.primaryAddressForm.address_0_postcode = val.id;
				}
			},
			deep: true,
		},
		input_country_secondary: {
			handler: function (val) {
				if (val) {
					this.secondaryAddressForm.address_1_country = val.id;
				}
			},
			deep: true,
		},
		input_province_secondary: {
			handler: function (val) {
				if (val) {
					this.secondaryAddressForm.address_1_province = val.id;
				}
			},
			deep: true,
		},
		input_city_secondary: {
			handler: function (val) {
				if (val) {
					this.secondaryAddressForm.address_1_city = val.id;
				}
			},
			deep: true,
		},
		input_postcode_secondary: {
			handler: function (val) {
				if (val) {
					this.secondaryAddressForm.address_1_postcode = val.id;
				}
			},
			deep: true,
		},
		sameAsPrimaryAddress: {
			handler: function (val) {
				if (val) {
					this.input_country_secondary = this.input_country;
					this.input_province_secondary = this.input_province;
					this.input_city_secondary = this.input_city;
					this.input_postcode_secondary = this.input_postcode;
					this.secondaryAddressForm.address_1_street =
						this.primaryAddressForm.address_0_street;
				} else {
					this.secondaryAddressForm = {
						address_1_country: "",
						address_1_postcode: "",
						address_1_province: "",
						address_1_city: "",
						address_1_street: "",
					};
					this.resetCountrySecondary();
					this.resetProvinceSecondary();
					this.resetCitySecondary();
					this.resetPostcodeSecondary();
				}
			},
			deep: true,
		},
		parentInformationForm: {
			handler: function (val) {
				// Check if parentInformationForm has changed
				const isParentInformationFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalParentInformationForm);

				// Update the submitParentInformationFormDisabled based on the change status
				this.submitParentInformationFormDisabled =
					!isParentInformationFormChanged;
			},
			deep: true,
		},
		primaryAddressForm: {
			handler: function (val) {
				// Check if primaryAddressForm has changed
				const isPrimaryAddressFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalPrimaryAddressForm);

				// Update the submitPrimaryAddressFormDisabled based on the change status
				this.submitPrimaryAddressFormDisabled =
					!isPrimaryAddressFormChanged;
			},
			deep: true,
		},
		secondaryAddressForm: {
			handler: function (val) {
				// Check if secondaryAddressForm has changed
				const isSecondaryAddressFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalSecondaryAddressForm);

				// Update the submitSecondaryAddressFormDisabled based on the change status
				this.submitSecondaryAddressFormDisabled =
					!isSecondaryAddressFormChanged;
			},
			deep: true,
		},
		emailAddressCommunicationForm: {
			handler: function (val) {
				// Check if emailAddressCommunicationForm has changed
				const isEmailAddressCommunicationFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalEmailAddressCommunicationForm);

				// Update the submitEmailAddressCommunicationFormDisabled based on the change status
				this.submitEmailAddressCommunicationFormDisabled =
					!isEmailAddressCommunicationFormChanged;
			},
			deep: true,
		},
		emergencyContactForm: {
			handler: function (val) {
				// Check if emergencyContactForm has changed
				const isEmergencyContactFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalEmergencyContactForm);

				// Update the submitEmergencyContactFormDisabled based on the change status
				this.submitEmergencyContactFormDisabled =
					!isEmergencyContactFormChanged;
			},
			deep: true,
		},
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
.form-control {
	border: 3px solid; /* You can adjust the border color and width as needed = #c41a1a !important; */
}
</style>
